import styled from "styled-components";

export const TitleBox = styled.div`
  border: ${(props) => props.theme.border.gray2};
  padding: 10px;
  .title {
    font-weight: 700;
    font-size: 18px;
    margin-bottom: 10px;
    padding: 10px;
    border: ${(props) => props.theme.border.gray1};
    text-align: center;
  }
`;

export const ListBox = styled.div`
  border: ${(props) => props.theme.border.gray2};
  padding: 10px;
  margin: 20px 0;
  overflow-x: auto;
  .table-top {
    display: flex;
    justify-content: space-between;
    margin-bottom: 10px;
    @media (max-width: 860px) {
      display: none;
    }
    button {
      width: 100px;
      height: 40px;
      background-color: ${(props) => props.theme.color.red};
      border-color: ${(props) => props.theme.color.red};
    }
    .table-top-left {
      display: flex;
      align-items: center;
      gap: 10px;
      .total-cnt {
        font-size: 1rem;
        font-weight: 700;
      }
      select {
        border: ${(props) => props.theme.border.gray2};
        width: 12px;
        padding: 10px;
        height: 40px;
      }
      input {
        border: ${(props) => props.theme.border.gray1};
        outline: none;
        padding: 10px;
        width: 200px;

        height: 40px;
        &:focus {
          border: ${(props) => props.theme.border.solid3};
          box-shadow: 0 0 0 2px ${(props) => props.theme.color.shadow.blue};
          outline: none;
        }
        &:focus::placeholder {
          color: transparent;
        }
      }
    }
  }
`;

export const TableWrap = styled.div`
  width: 100%;
  overflow-y: auto;
`;

export const SearchBox = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  select {
    border: ${(props) => props.theme.border.gray2};
    width: 120px;
    padding: 10px;
    height: 40px;
  }
  input {
    border: ${(props) => props.theme.border.gray1};
    outline: none;
    padding: 10px;
    width: 200px;

    height: 40px;
    &:focus {
      border: ${(props) => props.theme.border.solid3};
      box-shadow: 0 0 0 2px ${(props) => props.theme.color.shadow.blue};
      outline: none;
    }
    &:focus::placeholder {
      color: transparent;
    }
  }
`;

export const TotalCount = styled.div`
  font-size: 1rem;
  font-weight: 700;
`;

export const ControlWrap = styled.div`
  display: flex;
  justify-content: space-between;
  @media (max-width: 860px) {
    display: none;
  }
`;

export const ModalWrap = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 3;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  animation: modal-bg-show 0.3s;

  @keyframes modal-bg-show {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
`;

export const Modal = styled.div`
  width: 450px;
  height: max-content;
  background-color: ${(props) => props.theme.color.white};
  @media (max-width: 600px) {
    width: 360px;
  }
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
`;

export const Toolbar = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 1.25rem;
  @media (max-width: 860px) {
    display: none;
  }
`;
export const ControlBox = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;

  > div {
    display: flex;
    gap: 10px;
  }
`;

export const PaginationBox = styled.div`
  width: 100%;
  margin-top: 20px;
  display: flex;
  justify-content: center;
`;

export const PhoneNumberBox = styled.div`
  display: flex;
  gap: 10px;
  justify-content: space-between;
  align-items: flex-end;
  margin-top: 16px;

  > span {
    margin-bottom: 5px;
  }
`;

export const Error = styled.p`
  color: #fa5252;
  font-size: 12px;
  margin-top: 5px;
`;
